// extracted by mini-css-extract-plugin
export default {"delivery":"ProductListDeliveryMethod-delivery-1i1","item":"ProductListDeliveryMethod-item-4_G"};